export default {
  props: {
    value: [Object, Boolean],
  },
  data() {
    return {
      shown: false,
    };
  },
  watch: {
    value(value) {
      this.shown = !!value;
    },
    shown(value) {
      if (!value) {
        this.$emit('input', value);

        this.afterModalClose();
      } else {
        this.afterModalShow();
      }
    },
  },
  mounted() {
    this.shown = !!this.value;
  },
  methods: {
    afterModalShow() {},
    afterModalClose() {},
    close() {
      this.shown = false;
    },
  },
};
